import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'it',
    conver: 'it-IT',
    alia: 'it',
    region: 'Italy',
    regionText: 'Italia',
    language: 'Italian',
    languageText: 'Italian',
    appId: 13,
    acceptLanguage: 'it-IT,it;q=0.9',
};
export default theLocale;
